import React, { useState } from 'react'
import API from '../../utils/API'
import { FormattedMessage } from 'react-intl';

function ResendVerificationEmail(props) {
  const [email, setEmail] = useState('')
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')
  const [submitted, setsubmitted] = useState(false)

  function handleSubmit() {
    setsubmitted(true);
    setSuccess(false);
    setError('');
    API.resendVerifyForCMSECreateAccount(email)
    .then((res) => {
        console.log('Successfully resent to', email);
        setsubmitted(false);  
        setSuccess(true);    
    })
    .catch(err => {
        if(err.response && err.response.data){
          setError(err.message);
        }
        setsubmitted(false);    
    })
  }

  const handleDone = (event) => {
    event.preventDefault()
    window.location = '/login'
  }

  return (
    <div>
      <div className='password container py-5 h-100'>
        <div className='row d-flex justify-content-center p-3'>
          <div className='col-xl-4'>
            <form>
              <div className='header text-center mb-4'>
                <h2><FormattedMessage id="RESEND_VERIFICATION_EMAIL" /></h2>
              </div>
                {success ? 
                  <div className='card'>
                    <div className='form-outline text-center mt-2 mb-2'>
                      <FormattedMessage id="RESEND_VERIFICATION_EMAIL_SENT" values={{email: email}}/>
                    </div>
                    <button type='button' className='btn btn-primary btn-block' onClick={handleDone}><FormattedMessage id="DONE_BTN" /></button>
                  </div> :
                    <div className='card'>
                      <div className='form-outline mb-4'>
                          <label className='form-label' id='emailAddressLabel' htmlFor='form2Example1'><FormattedMessage id="EMAIL_ADDRESS" /></label>
                          <input className='form-control rounded-1' id='emailAddressField' value={email} name='email' type='email' onChange={(e) => setEmail(e.target.value)} />
                      </div>
                      {error ? <p className='error'>{error}</p> : null}
                      <button type='button' className='btn btn-primary btn-block' onClick={handleSubmit} disabled={submitted}><FormattedMessage id="SUBMIT"/></button>
                    </div>
                }
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResendVerificationEmail